// extracted by mini-css-extract-plugin
export default {"ratingContainer":"AddReview_ratingContainer__1vclw","addReviewForm":"AddReview_addReviewForm__f0qrH"};